var colors = {
  purple: {
    50: '#edf2fe',
    100: '#d1dbfc',
    200: '#a5b7fa',
    300: '#758ef0',
    400: '#526ce2',
    500: '#1f3cd0',
    600: '#162db2',
    700: '#0f2195',
    800: '#091678',
    900: '#050e63'
  },
  green: {
    50: '#f2feee',
    100: '#d2fad2',
    200: '#a6f5ad',
    300: '#75e38a',
    400: '#4fc872',
    500: '#20a453',
    600: '#178d50',
    700: '#10764b',
    800: '#0a5f44',
    900: '#064e3f'
  },
  blue: {
    50: '#eafefd',
    100: '#caf4fd',
    200: '#97e5fb',
    300: '#62cbf4',
    400: '#3baee9',
    500: '#0184db',
    600: '#0066bc',
    700: '#004c9d',
    800: '#00367f',
    900: '#002669'
  },
  orange: {
    50: '#fefbee',
    100: '#fdf1d5',
    200: '#fbe0ac',
    300: '#f4c681',
    400: '#e9ac60',
    500: '#db8630',
    600: '#bc6823',
    700: '#9d4e18',
    800: '#7f360f',
    900: '#692609'
  },
  red: {
    50: '#fef5ed',
    100: '#fdded3',
    200: '#fbb7a9',
    300: '#f4857c',
    400: '#e95a5c',
    500: '#db283b',
    600: '#bc1d3c',
    700: '#9d143b',
    800: '#7f0c38',
    900: '#690735'
  },
  gray: {
    50: '#f8fafd',
    100: '#eff1f6',
    200: '#e0e3ee',
    300: '#bec2d5',
    400: '#9499ae',
    500: '#6c7089',
    600: '#4a4e66',
    700: '#363a52',
    800: '#242841',
    900: '#191b34'
  },
  white: '#ffffff',
  black: '#000000',
  transparent: 'transparent',
  text: {
    "default": '#0c0d1d',
    gray: '#191b34',
    purple: '#010539',
    green: '#01292d',
    blue: '#000f3c',
    orange: '#3c0802',
    red: '#3c022f'
  }
};
var fontWeights = {
  regular: '500',
  medium: '600',
  bold: '700'
};
var fontSizes = {
  body: '1rem',
  h1: '2.618rem',
  h2: '1.618rem',
  h3: '1.17rem'
};
var lineHeights = {
  body: '1.618rem',
  h1: '3rem',
  h2: '2rem',
  h3: '1.618rem'
};
var letterSpacings = ['-0.02rem', '0.02rem'];
var space = {
  xxsmall: 4,
  xsmall: 8,
  small: 16,
  medium: 24,
  large: 32,
  xlarge: 48,
  xxlarge: 64
};
var sizes = space;
var radii = [0, 2, 4];
var outline = "0 0 0 3px";
var shadows = {
  // provide value w/o color so dynamic outline color can be added later,
  // e.g., `theme => ${theme.shadows.outline} ${non-default color}`
  outline: outline,
  outlineDefault: "".concat(outline, " ").concat(colors.purple['300']),
  elevation: {
    100: '0px 1px 2px rgba(0, 0, 0, 0.15)',
    200: '0px 1px 4px rgba(0, 0, 0, 0.25)',
    300: '0px 2px 6px rgba(0, 0, 0, 0.35)',
    400: '0px 4px 8px rgba(0, 0, 0, 0.45)'
  }
};
var theme = {
  colors: colors,
  fontWeights: fontWeights,
  space: space,
  sizes: sizes,
  radii: radii,
  fontSizes: fontSizes,
  lineHeights: lineHeights,
  letterSpacings: letterSpacings,
  shadows: shadows
};
export { theme };